// index.js or main file
import React, { useState,useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/login/login';
import Game from './pages/game/game';
import Intro from './pages/intro/intro';
import Thankyou from './pages/thankyou/thankyou';
import Admin from './admin/admin';
import DDDUI from './pages/dddUI/ddd';

const FROM_MOBILE_APP_SESSION_KEY = "bin_toss_fromMobileApp";

function usePageBackground() {
  const location = useLocation();

  useEffect(() => {
    const body = document.body;

    body.classList.remove('common-bg');

    switch (location.pathname) {
      case '/':
      case '/login':
        body.classList.add('common-bg');
        body.classList.add('common-bg1');

        break;
      case '/game':
        body.classList.remove('rules-bg');
        body.classList.add('common-bg');
        break;
     
      case '/intro':
        body.classList.add("common-bg", "rules-bg");
        break;
      case '/admin':
        body.classList.add('common-bg');
        break;
      case '/thankyou':
        body.classList.add('common-bg');
                body.classList.add('common-bg1');
        break;
   
        default:
        break;
    }
  }, [location]); 
}


function App() {
  usePageBackground();
  const navigate = useNavigate();
  const location = useLocation();

  const [mobileAppEmbed, setMobileAppEmbed] = useState(() => {
    try {
      return sessionStorage.getItem(FROM_MOBILE_APP_SESSION_KEY) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const loginRoute =
      location.pathname === "/" || location.pathname === "/login";
    const fromMobileAppParam = String(
      new URLSearchParams(location.search).get("fromMobileApp") || ""
    ).toLowerCase();
    const fromUrl =
      fromMobileAppParam === "true" || fromMobileAppParam === "1";
    if (loginRoute && fromUrl) {
      try {
        sessionStorage.setItem(FROM_MOBILE_APP_SESSION_KEY, "1");
      } catch {
        /* ignore quota / private mode */
      }
      setMobileAppEmbed(true);
    }
  }, [location.pathname, location.search]);

     // Get initial image from sessionStorage or env variable
     const getInitialImage = () => {
       return sessionStorage.getItem("orgData") || process.env.REACT_APP_EM_LOGO;
     };
   
     // State for header config
     const [headerConfig, setHeaderConfig] = useState({
       imageUrl: getInitialImage(),
       backButtonRedirect: "/", // Default back button
     });
   
     // Update both image and back button together (ONLY from Login)
     const updateHeader = ({ imageUrl, backButtonRedirect }) => {
       setHeaderConfig((prev) => ({
         imageUrl: imageUrl || prev.imageUrl, // Only update if provided
         backButtonRedirect: backButtonRedirect || prev.backButtonRedirect, // Only update if provided
       }));
   
       // Store image in sessionStorage if provided
       if (imageUrl) sessionStorage.setItem("orgData", imageUrl);
     };
   
   
     const handleBack = () => {
       const { backButtonRedirect } = headerConfig;
   
       if (backButtonRedirect.length > 20) {
         // Open in new tab (External Link)
         window.location.href = backButtonRedirect;
       } else {
         // Internal Navigation
         navigate(backButtonRedirect);
       }
     };
   
  

  return (
<DDDUI
      imageUrl={headerConfig.imageUrl}
      onBack={handleBack}
      loginFromMobileApp={mobileAppEmbed}
    >
      <Routes>
        <Route path="/" element={<Login updateHeader={updateHeader}/>} />
        <Route path="/game" element={<Game updateHeader={updateHeader}/>} />
        <Route path="/login" element={<Login updateHeader={updateHeader} />} />
        <Route path="/intro" element={<Intro updateHeader={updateHeader}/>} />
        <Route path="/thankyou" element={<Thankyou updateHeader={updateHeader}/>} />
         <Route path="/admin" element={<Admin/>} />
      </Routes>
      </DDDUI>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
